import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { AnalyticsAttributesProvider, Modal, ModalTrigger, useAnalytics, useAnalyticsAttributes } from '../../components';
import { renderViewModel } from '../../render-view-model';
export default function UiModal({ model }) {
    const [isOpen, setIsOpen] = useState(false);
    const { id, content } = model;
    const { entryTitle, title, transitionType, transitionSpeed, modalSize, closeText, modalContent } = content;
    const { sendTrackEvent } = useAnalytics();
    const analyticsAttributes = useAnalyticsAttributes();
    return (_jsxs(AnalyticsAttributesProvider, Object.assign({ value: {
            eventColumn: title,
            eventContainer: model.type,
            labelEnglish: entryTitle
        } }, { children: [_jsx(ModalTrigger, Object.assign({ "data-testid": "ui-modal-trigger", onClick: () => {
                    setIsOpen(true);
                    sendTrackEvent('modalOpened', Object.assign(Object.assign({}, analyticsAttributes), { event: 'opened', eventComponent: model.type, label: title, labelEnglish: entryTitle, title, uuid: model.id }));
                }, as: model.content.modalTriggerBlock ? 'div' : 'span' }, { children: renderViewModel(model.content.modalTrigger) }), void 0), _jsx(Modal, Object.assign({ modal: {
                    id,
                    content: { transitionType, transitionSpeed, modalSize, closeText }
                }, isOpen: isOpen, close: () => {
                    setIsOpen(false);
                    sendTrackEvent('modalClosed', Object.assign(Object.assign({}, analyticsAttributes), { event: 'closed', eventComponent: model.type, label: title, labelEnglish: entryTitle, title, uuid: model.id }));
                } }, { children: renderViewModel(modalContent) }), void 0)] }), void 0));
}
//# sourceMappingURL=UiModal.js.map